import React, { useState, useEffect, useContext } from 'react'

import Other from './other/Other';
import PersonalData from './personal-data/PersonalData';
import Notifications from './notifications/Notifications';
import CasesSettlement from './cases-settlement/CasesSettlement';

import {Routes, Route} from 'react-router-dom';
import { EditedContext } from '../../../partials/Context';

function EditContent() {
  const [activBox, setActivBox] = useState(undefined)
  const edited = useContext(EditedContext);
  const {getCurrentLawyer, setLawyerData, setErrors, errors, lawyer_data} = edited || '' ;
  const {id} = lawyer_data || '';

    useEffect(() => {
      getCurrentLawyer(setLawyerData, setErrors)
      //eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    useEffect(() => {
      if (id)
        fetch(`/api/services/${id}`).then(res => {
          if (res.ok) {
            res.json().then(data => {
              if (data.length === 0) {
                setActivBox(false);
              } else {
                setActivBox(true);
              }
          })
        }
      })
    }, [id])

  return (
    <div id="edit-content">
        <Routes>
            <Route path='/dane-osobiste/' element={<PersonalData errors={errors} activBox={activBox}/>}/>
            <Route path='/ustawienia-powiadomien/' element={<Notifications errors={errors}/>}/>
            <Route path='/sprawy-i-rozliczenia/' element={<CasesSettlement errors={errors}/>}/>
            <Route path='/pozostale/' element={<Other errors={errors}/>}/>
        </Routes>
    </div>
  )
}

export default EditContent